const Colors = {
  primaryBlueGreen: '#009688',
  primaryBlueGreenLightTint: '#01bbaa',
  lightGray: 'rgba(0, 0, 0, 0.54)'
};

export default Colors;